var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85728 9.57143V5V9.57143Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.428711 3.85714L2.64585 1.39429C2.74158 1.28723 2.8741 1.22015 3.01705 1.20638C3.16 1.19262 3.30289 1.23318 3.41728 1.32L6.31442 3.54857C6.42417 3.63408 6.56134 3.67661 6.7002 3.6682C6.83907 3.65978 6.9701 3.60099 7.06871 3.50286L10.143 0.428574M0.714425 9.57143V7.28572M3.00014 9.57143V5M5.28585 9.57143V6.14286M7.57157 9.57143V7.28572M9.85728 9.57143V5",
    stroke: "#828282",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartStyle);
export default __webpack_public_path__ + "static/media/chart-style.f8c08ae3766698a00cfe741102285a7f.svg";
export { ForwardRef as ReactComponent };